import Publisher from '@/models/Publisher'
import Avatar from '@/models/Avatar'
import Api from '@/services/api'
import map from 'lodash/map'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {},
    publisherDetails: null
  },

  actions: {
    async getPublishers ({ commit }, params) {
      const query = Publisher.page(params.page || 1).include('avatar')

      if (params.search) {
        query.where('search', params.search)
      }

      const res = await query.get()

      commit('setPublisherList', res.data)
      commit('setPublisherListMeta', res.meta)
    },

    async getPublisherDetails ({ commit }, id) {
      const { data } = await Publisher.find(id)
      commit('setPublisherDetails', data)
    },

    async changeAvatar ({ commit }, formData) {
      const { data } = await Api.post(
        `admin/publishers/${formData.get('publisher_id')}/avatar`,
        formData
      )
      commit('setSelectedPublisherAvatar', data.data)
    },

    async createPublisher ({ commit }, formData) {
      let { data } = await Api.post('admin/publishers', formData)
      return data
    },

    async updatePublisher ({ commit }, formData) {
      let { data } = await Api.put(`admin/publishers/${formData.id}`, formData)
      commit('setPublisherDetails', data.data)
    },

    async removePublisher ({ commit }, id) {
      let { data } = await Api.delete(`admin/publishers/${id}`)
      return data
    },

    async toggleBlock ({ commit }, formData) {
      let { data } = await Api.put(`admin/publishers/${formData.id}/block`)
      commit('setPublisherDetails', data.data)
    }
  },

  mutations: {
    setPublisherList (state, publishers) {
      state.list = map(publishers, publisher => {
        if (publisher instanceof Publisher) {
          return publisher
        } else {
          return new Publisher(publisher)
        }
      })
    },

    setPublisherListMeta (state, meta) {
      state.listMeta = meta
    },

    setPublisherDetails (state, publisher) {
      if (publisher instanceof Publisher) {
        state.publisherDetails = publisher
      } else {
        state.publisherDetails = new Publisher(publisher)
      }
    },

    setSelectedPublisherAvatar (state, avatar) {
      if (avatar instanceof Avatar) {
        state.publisherDetails.avatar = avatar
      } else {
        state.publisherDetails.avatar = new Avatar(avatar)
      }
    },

    clearPublisherDetails (state) {
      state.publisherDetails = null
    },

    publisherAvatarRemoved (state) {
      state.publisherDetails.avatar = null
    }
  }
}
